import { LeadInfoPageModel, getLeadLeadPageInfo } from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import CompaniesPage from "components/Companies/CompaniesPage"
import FailurePage from "components/Companies/FailurePage"
import SuccessPage from "components/Companies/SuccessPage"
import { GetStaticProps } from "next"
import { useState } from "react"

type CompaniesProps = {
  seo: SeoMetadataWithImage
  data: LeadInfoPageModel
}

export const getStaticProps: GetStaticProps<CompaniesProps> = async () => {
  const { data } = await getLeadLeadPageInfo()

  const seo = {
    title: data?.body?.pageTitle,
    description: data?.body?.metaDescription,
    keywords: data?.body?.keywords,
  }
  return {
    props: { data: data?.body, seo },
    revalidate: 60,
  }
}

export enum CompaniesSteps {
  COMPANIES = 1,
  FAIL = 2,
  SUCCESS = 3,
}

const Companies = ({ data, seo }: CompaniesProps) => {
  const [companiesSteps, setCompaniesSteps] = useState(1)
  return (
    <>
      <SeoMetaData data={seo} />
      {companiesSteps === CompaniesSteps.FAIL && (
        <FailurePage setCompaniesSteps={setCompaniesSteps} />
      )}
      {companiesSteps === CompaniesSteps.COMPANIES && (
        <CompaniesPage data={data} setCompaniesSteps={setCompaniesSteps} />
      )}
      {companiesSteps === CompaniesSteps.SUCCESS && <SuccessPage />}
    </>
  )
}
export default Companies
